module.exports = __webpack_public_path__ + "src/img/caifang.f2eeea33.svg";